import cn from 'classnames'
import { FC, ReactNode } from 'react'

import { Translation } from 'cng-common/features/translations'
import { TReplaceOptions } from 'cng-common/features/translations/components/translation/models/replaceOptions'
import { Button } from 'core-components/library/button'
import { ProgressBar, Tag, TQualityBand } from 'partner360/components/qualityIndicator'
import { TRANSLATION_KEYS } from 'partner360/features/keyInitiatives/configs/translations'

import styles from './QualityPillar.module.scss'

const NO_DATA_PLACEHOLDER = '—'

interface IQualityPillarProps {
  title: string
  score: number | null
  band: TQualityBand | null
  description: string
  descriptionAction?: ReactNode
  beforeActions?: ReactNode
  progressBand?: TQualityBand
  descriptionReplaceParams?: TReplaceOptions[]
  isNotApplicable?: boolean
  notApplicableText?: string
  successText?: string
  actionText?: string
  actionReplaceParams?: TReplaceOptions[]
  isActionActive?: boolean
  onAction?: () => void
  leadingAction?: ReactNode
  children?: ReactNode
  onHowScore: () => void
}

export const QualityPillar: FC<IQualityPillarProps> = ({
  title,
  score,
  band,
  description,
  descriptionReplaceParams,
  descriptionAction,
  beforeActions,
  progressBand,
  isNotApplicable,
  notApplicableText = TRANSLATION_KEYS.quality.notApplicable,
  successText,
  actionText,
  actionReplaceParams,
  isActionActive,
  onAction,
  leadingAction,
  children,
  onHowScore,
}) => {
  return (
    <div className={styles.pillar}>
      <div className={styles.pillarHeader}>
        <div>
          <div className={styles.pillarTitle}>
            <Translation text={title} />
          </div>
        </div>

        <div className={styles.pillarScoreWrapper}>
          {score === null || band === null ? (
            <span className={styles.pillarScore}>{NO_DATA_PLACEHOLDER}</span>
          ) : (
            <>
              <span className={styles.pillarScore}>{score}%</span>
              <Tag variant={band} />
            </>
          )}
        </div>
      </div>

      <div className={styles.descriptionRow}>
        <div className={styles.pillarDescription}>
          <Translation
            text={isNotApplicable ? notApplicableText : description}
            replaceParams={descriptionReplaceParams}
          />
        </div>
        {descriptionAction}
      </div>

      {score !== null && <ProgressBar value={score} band={progressBand} />}

      {beforeActions}

      <div className={cn(styles.actions, { [styles.actions__withoutMargin]: score === null })}>
        <div className={styles.actionGroup}>
          {leadingAction}
          {successText && (
            <span className={styles.successText}>
              <Translation text={successText} />
            </span>
          )}

          {!isNotApplicable && actionText && (
            <Button variant={isActionActive ? 'contained' : 'outlined'} onClick={onAction}>
              <Translation text={actionText} replaceParams={actionReplaceParams} />
            </Button>
          )}
        </div>
        <Button className={styles.howScoreButton} onClick={onHowScore} variant={'outlined'}>
          <Translation text={TRANSLATION_KEYS.quality.actions.howWeScore} />
        </Button>
      </div>

      {children}
    </div>
  )
}
